import type { Components } from "@mui/material";

export const MuiFormControlThemeOptions: Components["MuiFormControl"] = {
  styleOverrides: {
    root: {
      display: "block",
    },
  },
};
